export default "__VITE_ASSET__nXQarlpl__"